import { InfoDialogShell } from './NoteDialogParts';
import { directorText, eventText, exceptionalText, giftAidText, impairmentText, intangibleText } from './noteTexts';

/** The six static guidance dialogs (opened without data). */
export function GiftAidInfoDialog() {
  return <InfoDialogShell title={giftAidText.title} paragraphs={giftAidText.paragraphs} />;
}

export function ImpairmentAssetInfoDialog() {
  return <InfoDialogShell title={impairmentText.title} paragraphs={impairmentText.paragraphs} />;
}

export function IntangibleAssetInfoDialog() {
  return <InfoDialogShell title={intangibleText.title} paragraphs={intangibleText.paragraphs} />;
}

export function EventInfoDialog() {
  return <InfoDialogShell title={eventText.title} paragraphs={eventText.paragraphs} />;
}

export function ExceptionalItemInfoDialog() {
  return <InfoDialogShell title={exceptionalText.title} paragraphs={exceptionalText.paragraphs} />;
}

export function DirectorLoanInfoDialog() {
  return <InfoDialogShell title={directorText.title} paragraphs={directorText.paragraphs} />;
}
